var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',[_vm._v("Assistants Table")]),_c('b-table',{attrs:{"hover":"","responsive":"","items":_vm.tableItems,"fields":_vm.tableColumns,"busy":_vm.assistants.$isLoading},on:{"row-clicked":_vm.onRowClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }